// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3L_w6","location":"Header_location__1b4Gx"};